export enum ExplainabilityOriginSourceEnum {
  SpecificRoleText = 'SPECIFIC_ROLE_TEXT',
  SpecificRoleAttribute = 'SPECIFIC_ROLE_ATTRIBUTE',
  GeneralProfileText = 'GENERAL_PROFILE_TEXT',
  GeneralProfileAttribute = 'GENERAL_PROFILE_ATTRIBUTE',
}
